import * as Models from "../../";
export class OmnibusAssumedValues {
  name: string;
  code: string;
  marketTypeCode: string;
  displayStartDate?: Date;
  displayEndDate?: Date;
  effectiveStartDate?: Date;
  effectiveEndDate?: Date;
  inUse: boolean;
  defaultContractSignDate?: Date;
  epcCap: number;
  termLength: number;
  percentInvestmentContractSigning: number;
  percentInvestmentAtMechanicalCompletion: number;
  percentInvestmentAtPto: number;
  monthsFromContractSigningToMechanicalCompletion: number;
  monthsFromMechanicalCompletionToPto: number;
  developmentFeePercent: number;
  percentYield: number;
  percentDegredation: number;
  productionByMonth: { [key: number]: number };
  srecFactor: number;
  srecCommissionPercent: number;
  srecMintingPeriodLength: number;
  numberOfSrecYears: number;
  srecPriceIntervals:  Models.CostCalculation.MarketAssumedValuesModel.SrecPriceInterval[];
  relativeSrecSellingMonths: number[];
  operationManagementCostPerKw: number;
  operationManagementEscalator: number;
  operationManagementFreeStartYears: number;
  insuranceRate: number;
  insuranceEscalator: number;
  annualCellServiceFee: number;
  cellServiceFreeStartYears: number;
  cellServiceEscalator: number;
  inverterReplacementCostPerWatt: number;
  inverterReserveStartYear: number;
  inverterReplacementYear: number;
  assetManagementFeePerKw: number;
  systemRemovalNetRevenuePerWatt: number;
  investmentTaxCreditPercent: number;
  igsCorporateTaxRate: number;
  bonusDepreciationPercent: number;
  acceleratedDepreciationPoints: Models.CostCalculation.MarketAssumedValuesModel.IAcceleratedDepreciationPoints[];
  taxAllocationPercent: number;
  fundingMultiplier: number;
  preflipAnnualReturnRate: number;
  preflipCommonCashSharePercent: number;
  postflipEbitdaPercent: number;
}
